import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon66: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M14.464 0c.296 0 .536.224.536.5v6c0 .276-.24.5-.536.5-.296 0-.535-.224-.535-.5V1H1.071v18h3.75c.296 0 .536.224.536.5s-.24.5-.536.5H.536C.24 20 0 19.776 0 19.5V.5C0 .224.24 0 .536 0h13.928Zm2.257 9.439.841.839a1.502 1.502 0 0 1-.001 2.121l-1.53 1.53-5.919 5.918a.523.523 0 0 1-.37.153H7.523A.523.523 0 0 1 7 19.477v-2.219c0-.139.055-.272.153-.37L14.6 9.44a1.498 1.498 0 0 1 2.121-.001Zm-1.38.741-1.529 1.528-5.766 5.766v1.48h1.48l5.766-5.765 1.529-1.529a.455.455 0 0 0 .001-.642l-.841-.839a.451.451 0 0 0-.64.001ZM7.5 10a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h4Zm3-3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h7Zm0-3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h7Z"
      />
    </Svg>
  )
}
